export var CxmRulesClientHeader;
(function(CxmRulesClientHeader) {
    CxmRulesClientHeader[/**
     * Determines the response data type, e.g. 'application/json'
     */ "Accept"] = "Accept";
    CxmRulesClientHeader[/**
     * The Global Authentication Service (GAS) token used for authentication.
     */ "Authorization"] = "Authorization";
    CxmRulesClientHeader[/**
     * Determines the response data type, e.g. 'application/json'
     */ "ContentType"] = 'Content-Type';
})(CxmRulesClientHeader || (CxmRulesClientHeader = {}));
